export const initialState = {
  isFetching: false,
}

export const setFetchingStatus = (state, payload) => (
  { isFetching: payload }
)
